import React from 'react';
import {
    Box, ListItemText,
    MenuItem,
} from '@mui/material';
import fieldId from '../../hooks/fieldId';
import conditionId from '../../hooks/conditionId';
import { fieldNameEnum } from '../../enums/fieldNameEnum';
import CustomModal from "../../components/Modal/CustomModal";
import {CustomSelectAndChildren} from "../../components/CustomSelectAndChildren";
import {CustomSelect} from "../../components/CustomSelect";
import {CustomTextField} from "../../components/CustomTextField";
import {CustomDatePicker} from "../../components/CustomDatePicker";
import {CustomAntSwitch} from "../../components/CustomAntSwitch";
import CustomCardContainer from "../../components/CustomCardContainer";
import CustomListContainer from "../../components/CustomListContainer";
import CustomListItem from "../../components/CustomListItem";
import ButtonIcon from "../../components/buttons/ButtonIcon";
import {CleanIcon, TrashOutlineIcon} from "../../components/buttons/IconButtons";
import {ButtonNextStep} from "../../components/buttons/ButtonNavigation";
import SearchForApp from "./Functionality/SearchForApp";
import ButtonSubAction from "../../components/buttons/ButtonSubAction";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {Clear} from "@mui/icons-material";
import {getFieldNameByValue} from "./Model/Model";
import {EMPTY_VALUES} from "../../Apis/functions";

const SearchFor = (props) => {
    const {
        open,
        onClose,
        onFiltered,
        moduleId,
        option,
        finalArray,
        modelType,
        setSearch,
        cleanAdvance,
        setCleanAdvance,
        cleanRules,
        setFinalArray,
        searchElement,
        userId = null,
        noShowFilters = null,
        callGetValuesApi=null,
        isAttendance
    } = props;

    const {
        t,
        advancedSearch,
        setTypeAttribute,
        fieldName,
        setFieldName,
        field,
        setField,
        sort,
        setSort,
        emptyFields,
        operationKey,
        setOperationKey,
        condition,
        setCondition,
        inputDropdown,
        typeAttribute,
        valueAttribute,
        setValueAttribute,
        fromValue,
        setFromValue,
        toValue,
        setToValue,
        dateAttribute,
        isValidDate,
        setIsValidDate,
        isValidFrom,
        setIsValidFrom,
        isValidTo,
        setIsValidTo,
        checked,
        inputDate,
        inputTwoDates,
        inputTwoNumbers,
        inputString,
        inputNumber,
        inputTransferableList,
        listRules,
        availablesList,
        assignedList,
        attributesFilter,
        getConditionFilter,
        getValues,
        handleDateChange,
        handleFromDateChange,
        handleToDateChange,
        handleAssign,
        handleDeallocate,
        transferAllToAssigned,
        transferAllToAvailables,
        handleAddRule,
        handleDeleteRule,
        handleChange,
        handleSearch,
        handleClear,
        handleDeleteAllRules
    } = SearchForApp({
        open,
        onFiltered,
        moduleId,
        option,
        finalArray,
        modelType,
        setSearch,
        cleanAdvance,
        setCleanAdvance,
        cleanRules,
        setFinalArray,
        searchElement,
        userId,
        noShowFilters,
        callGetValuesApi,
        isAttendance
    });


    return (
        <CustomModal
            show={open}
            title={"advance_search"}
            size="lg"
            buttonConfirm="search"
            cancelButton={true}
            confirmButton={true}
            onConfirm={() =>{
                if(listRules?.length === 0 && finalArray.length > 0){
                    setCleanAdvance(true);
                    return;
                }

                if (advancedSearch) {
                    handleSearch();
                } else {
                    handleAddRule();
                }
            }}
            onHide={onClose}
            disabled={listRules?.length === 0 && finalArray.length === 0}
        >
            <div className={"row"}>
                <div className={'col-12 mb-2 d-flex justify-content-end'}>
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_sfr_clean_all_inputs'
                        Icon={CleanIcon}
                        title={'clear_instances'}
                        onClick={handleClear}
                        iconProps='btn-icon-svg-12px icon-color-general-00'
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    <CustomSelectAndChildren id={"slt_sfr_field"}
                                             name={"field"}
                                             trans={"field"}
                                             onChange={(e) => {
                                                 setTypeAttribute(
                                                     attributesFilter.find((item) => item.id === e.target.value).fieldType,
                                                 );
                                                 setFieldName(
                                                     attributesFilter.find((item) => item.id === e.target.value).field,
                                                 );
                                                 setField(e.target.value);
                                             }}
                                             value={field}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                    >
                        {attributesFilter?.map((item) => (
                            <MenuItem key={item?.id} value={item?.id}>
                                {fieldId(item?.id) || EMPTY_VALUES.DEFAULT}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
                {advancedSearch &&
                    <Box className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                        <CustomSelect id={"slt_sfr_sort_by"}
                                      name={"sortBy"}
                                      value={sort}
                                      keyName="id"
                                      onChange={(e) => setSort(e.target.value)}
                                      list={[{id:"ASC", name:"ASC"}, {id:"DESC", name:"DESC"}]}
                                      trans={"sort"}
                                      label={"lbl_sfr_sort_by"}
                                      emptyFields={emptyFields}
                                      required={true}
                                      showNoSelectionOption={false}
                        />
                    </Box>
                }
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    <CustomSelectAndChildren
                        id={"slt_sfr_condition"}
                        name={"condition"}
                        trans={"condition"}
                        onChange={(e) => {
                            setOperationKey(
                                getConditionFilter.find((item) => item.id === e.target.value)
                                    .operationKey,
                            );
                            setCondition(e.target.value);
                        }}
                        value={condition}
                        required={false}
                        disabled={!field || ! sort}
                        showNoSelectionOption={false}
                    >
                        {getConditionFilter?.map((item) => {
                            return <MenuItem value={item.id}>{conditionId(item?.id) || EMPTY_VALUES.DEFAULT}</MenuItem>;
                        })}
                    </CustomSelectAndChildren>
                </div>
                {((!advancedSearch && !inputTransferableList && condition !== '' && !['NU', 'NN'].includes(operationKey)) ||
                    advancedSearch) && (
                    <>
                        {(!advancedSearch || (advancedSearch && !inputTransferableList &&  condition !== '' && !['NU', 'NN'].includes(operationKey))) && (
                            <>
                                {inputDropdown && condition !== '' && (
                                    <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                                        <CustomSelectAndChildren id={"slt_sfr_value"}
                                                                 name={"value"}
                                                                 trans={"value"}
                                                                 onChange={(e) => {
                                                                     setValueAttribute(e.target.value);
                                                                 }}
                                                                 value={valueAttribute}
                                                                 required={true}
                                                                 emptyFields={emptyFields}
                                                                 showNoSelectionOption={false}
                                        >
                                            {typeAttribute === 'BOOLEAN'
                                                ? getValues?.map((item, index) => {
                                                    return (
                                                        <MenuItem
                                                            value={
                                                                item.toLowerCase() === 'true'
                                                                    ? true
                                                                    : item.toLowerCase() === 'false' && false
                                                            }
                                                        >
                                                            {t(item.toLowerCase()).toUpperCase()}
                                                        </MenuItem>
                                                    );
                                                })
                                                : typeAttribute === 'UUID'
                                                    ? getValues?.map((item, index) => {
                                                        return <MenuItem value={item.id}>{item.name}</MenuItem>;
                                                    })
                                                    : getValues?.map((item, index) => {
                                                        return (
                                                            <MenuItem value={item}>
                                                                {getFieldNameByValue(fieldName)
                                                                    ? t(
                                                                        fieldNameEnum[fieldName][+item],
                                                                    ).toUpperCase()
                                                                    : item}
                                                            </MenuItem>
                                                        );
                                                    })}
                                        </CustomSelectAndChildren>
                                    </div>
                                )}
                                {inputTwoNumbers && condition !== '' && (
                                    <>
                                        <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                                            <CustomTextField
                                                id='txt_sfr_from_value'
                                                name='fromValue'
                                                value={fromValue}
                                                trans={"from"}
                                                type={"number"}
                                                disabled={false}
                                                onChange={(e) => setFromValue(e.target.value)}
                                            />
                                        </div>
                                        <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                                            <CustomTextField
                                                id='txt_sfr_to_value'
                                                name='toValue'
                                                value={toValue}
                                                trans={"to"}
                                                type={"number"}
                                                disabled={false}
                                                onChange={(e) => setToValue(e.target.value)}
                                            />
                                        </div>
                                    </>
                                )}
                                {inputDate && condition !== '' && (
                                    <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                                        <CustomDatePicker id={"dp_sfr_date"}
                                                          name={'dateAttribute'}
                                                          disabled={false}
                                                          onChange={handleDateChange}
                                                          trans={"date"}
                                                          value={dateAttribute}
                                                          required={true}
                                                          openTo={"day"}
                                                          onError={(error) => setIsValidDate(error === null)}
                                                          isValid={isValidDate}
                                                          emptyFields={emptyFields}

                                        />
                                    </div>
                                )}
                                {inputTwoDates && condition !== '' && (
                                    <div className={"row m-0 p-0"}>
                                        <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                                            <CustomDatePicker id={"dp_sfr_from"}
                                                              name={'from'}
                                                              disabled={false}
                                                              onChange={handleFromDateChange}
                                                              trans={"from"}
                                                              value={fromValue}
                                                              required={true}
                                                              openTo={"day"}
                                                              onError={(error) => setIsValidFrom(error === null)}
                                                              isValid={isValidFrom}
                                                              emptyFields={emptyFields}

                                            />
                                        </div>
                                        <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                                            <CustomDatePicker id={"dp_sfr_to"}
                                                              disabled={fromValue === null}
                                                              name={'to'}
                                                              onChange={handleToDateChange}
                                                              trans={"to"}
                                                              value={toValue}
                                                              required={true}
                                                              openTo={"day"}
                                                              onError={(error) => setIsValidTo(error === null)}
                                                              isValid={isValidTo}
                                                              emptyFields={emptyFields}
                                                              minDate={fromValue}

                                            />
                                        </div>
                                    </div>
                                )}
                                {(inputString || condition === '') && (
                                    <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                                        <CustomTextField
                                            id='txt_sfr_value'
                                            name='valueAttribute'
                                            value={valueAttribute}
                                            trans={"value"}
                                            type={inputNumber ? 'number' : 'text'}
                                            disabled={false}
                                            required={condition !== '' && !['NU', 'NN'].includes(operationKey)}
                                            emptyFields={emptyFields}
                                            onChange={(e) => setValueAttribute(e.target.value)}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
                {advancedSearch && (
                    <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                        <CustomAntSwitch id={"sch_sfr_search_criteria"}
                                         title={t('search_criteria').toUpperCase()}
                                         name={"searchCriteria"}
                                         checked={checked}
                                         onChange={handleChange}
                                         disabled={false}
                                         emptyFields={emptyFields}
                                         transLeft={"and"}
                                         transRight={"or"}
                        />
                    </div>
                )}
                {inputTransferableList && condition !== '' && (
                    <div className={'row m-0 p-0'}>
                        <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                            <CustomCardContainer
                                title={'availables'}
                                actions={
                                    <ButtonSubAction
                                        id='btn_sfr_add_all'
                                        name='add_all'
                                        onClick={transferAllToAssigned}
                                    />
                                }
                            >
                                <CustomListContainer>
                                    {availablesList?.map((element, index) => (
                                        <CustomListItem
                                            display={"flex"}
                                            key={index}
                                            actions={
                                                <ButtonIcon
                                                    id='btn_sfr_move_right'
                                                    Icon={ChevronRightIcon}
                                                    onClick={() => {
                                                        handleAssign(element);
                                                    }}
                                                    title={''}
                                                    className='btn-background-transparent'
                                                    iconProps={'btn-icon-svg-18px'}
                                                />
                                            }
                                        >
                                            <ListItemText primary={`${element?.name}`} />
                                        </CustomListItem>
                                    ))}
                                </CustomListContainer>
                            </CustomCardContainer>
                        </div>
                        <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                            <CustomCardContainer
                                title={'assigned'}
                                actions={
                                    <ButtonSubAction
                                        id='btn_sfr_remove_all'
                                        name='remove_all'
                                        onClick={transferAllToAvailables}
                                    />
                                }
                                emptyFields={emptyFields}
                            >
                                <CustomListContainer>
                                    {assignedList?.map((element, index) => (
                                        <CustomListItem
                                            display={"flex"}
                                            key={index}
                                            onClick={() => handleDeallocate(element)}
                                            classes={"text-break"}
                                            actions={
                                                <ButtonIcon
                                                    id='btn_sfr_clear'
                                                    Icon={Clear}
                                                    onClick={() => {
                                                        handleDeallocate(element)
                                                    }}
                                                    title={''}
                                                    className='btn-background-transparent'
                                                    iconProps={'btn-icon-svg-18px'}
                                                />
                                            }
                                        >
                                            <ListItemText primary={`${element?.name}`} />
                                        </CustomListItem>
                                    ))}
                                </CustomListContainer>
                            </CustomCardContainer>
                        </div>
                    </div>
                )}
                {advancedSearch && (
                    <>
                        <div className={"col-12 mb-4"}>
                            <ButtonNextStep
                                id="btn_sfr_add_rule"
                                text={"add_rule_to_search"}
                                click={handleAddRule}
                            />
                        </div>
                        <div className={'col-sm-12'}>
                            <CustomCardContainer
                                title={'rules'}
                                subtitle={
                                    <div className={'mb-2 d-flex justify-content-end'}>
                                        <ButtonIcon
                                            className='btn-clean-secondary-600'
                                            id='btn_sfr_clean_all_rules'
                                            Icon={CleanIcon}
                                            title={'clean_all_rules'}
                                            onClick={() => {
                                                handleDeleteAllRules();
                                                setSearch(false);
                                                setCleanAdvance(true);
                                            }}
                                            iconProps='btn-icon-svg-12px icon-color-general-00'
                                        /></div>
                                }
                            >
                                <CustomListContainer>
                                    {listRules?.map((element, index) => (
                                        <CustomListItem
                                            display={"flex"}
                                            key={index}
                                            actions={
                                                <ButtonIcon
                                                    id='btn_sfr_delete'
                                                    Icon={TrashOutlineIcon}
                                                    onClick={() => {
                                                        handleDeleteRule(index);
                                                    }}
                                                    title={''}
                                                    className='btn-background-transparent'
                                                    iconProps={'btn-icon-svg-18px btn-icon-svg-red'}
                                                />
                                            }
                                        >
                                            <ListItemText primary={`${element}`} />
                                        </CustomListItem>
                                    ))}
                                </CustomListContainer>
                            </CustomCardContainer>
                        </div>
                    </>
                )}
            </div>
        </CustomModal>
    );
};

export default SearchFor;
